/*
 * @description: 
 * @Author: Jay
 * @Date: 2023-12-19 16:30:46
 * @LastEditors: Jay
 * @LastEditTime: 2026-08-07 15:22:59
 */
const getters = {
  //身份 0则是商户 1是代理
  user_rankType: state => state.user.rankType,
  //动态路由-菜单
  permission_routes: state => state.permission.emnuRoutes,
  // 权限-控制
  roles_routes: state => state.permission.roles,
}
export default getters
